module.exports = __webpack_public_path__ + "img/4step-image2.f51cd9b5.png";